export interface IProduct {
  id: string;
  pricing: IPricing[];
  type: ProductType;
}

export enum ProductType {
  LITE = "one_time_payment",
  SUBSCRIPTION = "subscription",
  CARD = "card",
  SHIPPING = "shipping",
  CREDIT = "credit",
}

export enum SubscriptionType {
  BASIC = "Basic",
  LITE = "Lite",
  INDIVIDUAL = "Individual",
  PLUS = "Plus",
  TEAMS = "Teams",
  ORGANIZATION = "Organization",
  ENTERPRISE = "Enterprise",
  PREMIUM = "Premium",
}

export type IBillingScheme = "per_unit" | "tiered";

export interface IPricing {
  id: string;
  product_id: string;
  billing_scheme: IBillingScheme;
  currency: string;
  price: number;
  transform_quantity: {
    divide_by: number;
  } | null;
}
